import { ComponentProps, ForwardedRef, forwardRef } from 'react';

import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router';
import { isAbsoluteLink, isCloudQueryDomain, isDomain } from 'shared/base';

export const Link = forwardRef(
  (
    { href, rel, target, ...props }: Omit<ReactRouterLinkProps, 'to'> & ComponentProps<'a'>,
    ref: ForwardedRef<HTMLAnchorElement>,
  ) => {
    const isOutsideLink =
      href &&
      isAbsoluteLink(href) &&
      !isCloudQueryDomain({ url: href }) &&
      (process.env.VERCEL_ENV !== 'preview' || !isDomain('vercel.app', { url: href }));
    const parsedRel = rel ?? (isOutsideLink ? 'noopener noreferrer nofollow' : undefined);
    const parsedTarget = target ?? (isOutsideLink ? '_blank' : undefined);

    return (
      <ReactRouterLink ref={ref} rel={parsedRel} target={parsedTarget} to={href ?? ''} {...props} />
    );
  },
);
